class TestIdentityProviderConnection {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default TestIdentityProviderConnection;
